Object.values(document.querySelectorAll('.heroCarousel .navItems button')).forEach(button => {
  button.addEventListener('click', function () {
    Object.values(button.parentElement.querySelectorAll('button')).forEach(allButton => {
      allButton.classList.remove('active');
    });
    button.classList.add('active');
  });
});
